module.exports = __webpack_public_path__ + "static/media/wires.25804148.png";